@import 'apps/webcomponents/src/assets/common.scss';

.wrapper {
  flex-direction: column;
  height: 100%;
}

.content {
  flex-grow: 2;
  height: 100%;

  .grid {
    height: 100%;
  }

  .grid-view {
    min-height: 100%;
    align-items: stretch;
  }

  .header-buttons {
    padding-right: calc(2 * var(--spacer));
    margin-right: calc(2 * var(--spacer));
    position: relative;

    &:not(:empty) {
      &:after {
        content: '';
        position: absolute;
        right: 0;
        top: 2px;
        height: 80%;
        width: 1px;
        background-color: var(--chart-101-pressed-dividers);
      }
    }
  }
}
